var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9H20C20 6 16 3 12 3C8 3 4 6 4 9Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15V9",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28906 9.91064C8.28906 5.82861 9.89714 2.48877 12 2.48877C14.1029 2.48877 15.7109 5.82861 15.7109 9.91064",
    stroke: "#DCE3F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1 18L6 21",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9004 18L17.0004 21",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 17.9999H15.6C16.7 17.9999 17.7 17.5999 18.6 16.9999L20.4 15.5999C20.9 15.1999 21.1 14.4999 20.9 13.8999C20.6 12.8999 19.4 12.5999 18.6 13.1999L16.8 14.5999C16.5 14.8999 16 14.9999 15.6 14.9999H4.5C3.7 14.9999 3 15.6999 3 16.4999C3 17.2999 3.7 17.9999 4.5 17.9999Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetired);
export default __webpack_public_path__ + "static/media/retired.1f934e72223ee678131c54295842d1b0.svg";
export { ForwardRef as ReactComponent };